import { Options } from 'highcharts';
import React, { FC } from 'react';
import { FinancialStat } from '../types';
import {
  StatCellWrapper,
  StatLabelWrapper,
  StatsRowWrapper,
  StatValueWrapper,
  StyledDivider,
} from './common';

export interface FinancialStatsGridProps {
  stats: FinancialStat[];
  chartOptions?: Options;
}

export const FinancialStatsGrid: FC<FinancialStatsGridProps> = ({ stats }) => {
  return (
    <>
      <StatsRowWrapper>
        {stats.map(({ label, value }, index) => (
          <>
            <StatCellWrapper>
              <StatLabelWrapper>{label}</StatLabelWrapper>
              <StatValueWrapper>{value}</StatValueWrapper>
            </StatCellWrapper>
            {index !== stats.length - 1 && <StyledDivider />}
          </>
        ))}
      </StatsRowWrapper>
    </>
  );
};
